module.exports = __webpack_public_path__ + "static/media/checkmark.817623c1.svg";